import React, { useContext, useMemo } from 'react'
import { getValue } from 'firebase-utils'
import { ScreenSizeContext } from 'providers'
import { useLocation } from 'react-router-dom'
import { getErrorMessage } from '../../utils/helpers'
import StepWizard from '../shared/StepWizardClone/WizardClone'
import BrandsContext from '../../contexts/BrandsContext'
import { WizardProps } from '../shared/types/WizardProps'
import BusinessPaymentStep from './steps/BusinessPaymentStep'
import PaymentFailedDialog from '../shared/PaymentFailedDialog'
import BusinessInformationStep from './steps/BusinessInformationStep'
import BusinessAddressAndContact from './steps/BusinessAddressAndContact'

const Wizard = ({
    item,
    onSubmit,
    goToListPage,
    ...props
}: WizardProps): JSX.Element => {
    // const [submitPhase, setSubmitPhase] = useState<'idle' | 'waiting' | 'pending'>('idle')

    const {
        brandNetworkError,
        setBrandNetworkError,
        fetchBrands,
        initialFetchParams
    } = useContext(BrandsContext)
    const screenSize = useContext(ScreenSizeContext)

    const error = useMemo(() => brandNetworkError ? getErrorMessage(brandNetworkError) : null, [brandNetworkError])

    const showPaymentFailedDialog = useMemo(() => {
        return (
            Array.isArray(brandNetworkError) &&
            (
                brandNetworkError?.some?.((x) => x?.description === 'payment-failed') ||
                brandNetworkError?.some?.((x) => x?.description?.startsWith('Payment failed'))
            )
        )
    }, [brandNetworkError])

    const onClosePaymentFailedDialog = () => {
        fetchBrands(initialFetchParams)
        setBrandNetworkError(null)
        goToListPage?.()
    }

    const location = useLocation()
    const goDireactlyToPaymentStep = useMemo(() => {
        const queryParams = new URLSearchParams(location.search)
        return item?.registration_status === 'payment-failed' &&
        queryParams.has('payment-failed')
    }, [location.search, item?.registration_status])

    const steps = useMemo(() => {
        const mode = item ? 'editing' : 'creating'
        return [
            {
                id: 'business_info',
                label: getValue('sms_enrollment_business_information'),
                component: BusinessInformationStep,
                customBackButtonActionOnFirstStep: goToListPage,
                additionalProps: {
                    editing: item,
                    mode
                }
            },
            {
                id: 'business_address',
                label: getValue('sms_enrollment_address_and_contact'),
                component: BusinessAddressAndContact,
                additionalProps: {
                    editing: item,
                    mode
                }
            },
            {
                id: 'business_confirm',
                label: getValue('sms_enrollment_details'),
                component: BusinessPaymentStep,
                additionalProps: {
                    showAlert: true,
                    showConfirmation: true,
                    editing: item,
                    mode
                    // onCancel: () => setShowWizard(false)
                }
            }
        ]
    }, [item])

    return <div>
        <StepWizard
            steps={steps}
            onSubmit={onSubmit}
            error={error}
            onCloseError={setBrandNetworkError}
            enableBackButtonOnFirstStep
            smallView={screenSize.mobile}
            initialActiveStep={goDireactlyToPaymentStep ? steps[steps.length - 1].id : undefined}
            {...props}
        />
        <PaymentFailedDialog
            isOpen={showPaymentFailedDialog}
            onClose={onClosePaymentFailedDialog}
        >
            {getValue('sms_registration_brand_payment_failed_dialog_content')}
        </PaymentFailedDialog>
    </div>
}

export default Wizard
